import { useState } from 'react'

import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { Download } from '@factorialco/f0-react/icons/app'
import {
  FundaeFinishGroupExportDocument,
  FundaeFinishGroupExportMutation,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { LegalEntityModal } from './LegalEntityModal'

export function Header({
  selectedClassId,
  onError,
  perfil,
}: {
  selectedClassId?: string
  onError?(): void
  perfil?: string | null
}) {
  const { access } = useCurrentSession()
  const [showLegalEntityModal, setShowLegalEntityModal] = useState(false)
  const [exportTrainingsFundaeFinishGroup, { loading }] = useMutation(
    FundaeFinishGroupExportDocument,
    {
      extractorFn: (data: FundaeFinishGroupExportMutation) =>
        data.trainingsMutations.exportTrainingsFundaeFinishGroup,
    }
  )

  const onSubmit = async (legalEntityId?: string) => {
    const result = await exportTrainingsFundaeFinishGroup({
      variables: {
        trainingClassId: String(selectedClassId),
        authorId: access.id,
        ...(legalEntityId ? { legalEntityId } : {}),
      },
    })

    const handled = handleResult(result, (error) => {
      if (error.errors) {
        app.setFlash({
          type: 'wrong',
          message: error.errors,
        })
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('common.error'),
        })
      }
    })

    if (handled.success) {
      setShowLegalEntityModal(false)
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.fundae.finish_group_table.export.success'),
      })
    } else if (onError) {
      onError()
    }
  }

  const isGrupoDeEmpresa = perfil === 'Grupo de Empresa'

  return (
    <>
      <SectionHeader
        separator="bottom"
        title={i18n.t('trainings.trainings_detail.fundae.section_header.title')}
        description={i18n.t('trainings.trainings_detail.fundae.section_header.description')}
        link={{
          href: 'https://empresas.fundae.es/Lanzadera',
          label: i18n.t('trainings.trainings_detail.fundae.section_header.support_button.label'),
        }}
        action={{
          icon: Download,
          label: i18n.t('trainings.trainings_detail.fundae.section_header.action.label'),
          onClick() {
            track(trackingEvents.training.trainingDetail.fundae.finishGroupsExport.exportXml)
            if (isGrupoDeEmpresa) {
              setShowLegalEntityModal(true)
            } else {
              onSubmit()
            }
          },
        }}
      />
      {showLegalEntityModal && (
        <LegalEntityModal
          onClose={() => setShowLegalEntityModal(false)}
          onConfirm={(legalEntityId) => onSubmit(legalEntityId)}
          mutationLoading={loading}
        />
      )}
    </>
  )
}
